import { HongKongMoment as moment } from './HongKongMoment';
import { set } from 'lodash';
import { isString } from 'util';
import { IReduxInitialState } from '@interface/IReduxInitialState';
import { ICognitoUserPrincipal } from '@/interface/ICognitoUserPrincipal';

function toCamelCase(str): string {
  return str
    .toLowerCase()
    .replace(/[-_]+/g, ' ')
    .replace(/[^\w\s]/g, '')
    .replace(/ (.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/ /g, '');
}

export function objectToCamelCase(origObj) {
  return Object.keys(origObj).reduce(function (newObj, key) {
    let val = origObj[key];
    let newVal = typeof val === 'object' ? objectToCamelCase(val) : val;
    newObj[toCamelCase(key)] = newVal;
    return newObj;
  }, {});
}

export function* execSafeSaga(effects: Function, errorHandler?: Function) {
  try {
    yield effects();
  }
  catch (err) {
    console.error(err);
    if (errorHandler)
      return errorHandler();
  }
}

//TODO: any User Principal Interface
export function mapUserPrincipalState(state: IReduxInitialState): { profile: ICognitoUserPrincipal | {} } {
  return {
    profile: state.UserReducer.profile ? state.UserReducer.profile : {}
  }
}

export function propsToFormData(formData: {}, obj: {}, prefix?: string) {
  const keys = Object.keys(obj);
  if (prefix) {
    keys
      .forEach(key => {
        formData[`${prefix}.${key}`] = obj[key]
      });
  } else
    keys
      .forEach(key => formData[key] = obj[key])
}

// When passing date string to server, it's converted ISO format. YYYY-MM-DDThh:mm:ss.sssZ
// When receiving date string from server, it's treated as ISO format and converted to local time zone (default).
export const dateUtils = {
  parse: str => moment(str),
  toString: momentInstance => momentInstance.startOf('day').toISOString(),
};

//Convert ant design form data to json
export const FormToObjectHandler = (formData) => {
  const data = {};
  Object
    .keys(formData)
    .forEach(key => {
      const val = formData[key];
      if (val)
        set(data, key, val);
    });
  return data;
}

interface IVerticalDataProps {
  keySet: string[],
  data: any[]
}

interface IRowOrder {
  field: string;
  remarks?: string;
  render: (any) => any
}

export const verticalTableSrcConverter = (src: any[], keyField: string, rowOrder: IRowOrder[]): IVerticalDataProps => {
  const extract = {};
  const keySet = src.map(item => {
    const key = item[keyField];
    extract[key] = item;
    return key;
  });

  const converted = rowOrder
    .map((rowConfig) => {
      const { field, remarks, render } = rowConfig;
      const row = { 'vertical.title': {'title': field, 'remarks': remarks? remarks:null}};
      keySet.forEach(key => row[key] = render(extract[key][field]));
      return row;
    });

  return {
    keySet: ['vertical.title'].concat(keySet),
    data: converted
  };
}

export function triggerDownload(fileName: string, fileObj: Blob | string): void {
  let downloadLink = document.createElement("a");
  downloadLink.download = fileName;
  downloadLink.target = "_blank";

  if (isString(fileObj))
    downloadLink.href = fileObj;
  else
    downloadLink.href = window.URL.createObjectURL(fileObj);

  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
}

export function getAssetNumber(subAssetId: number): string {
  return `AS${Number(10000000) + subAssetId}`;
}